"use client"

import { CommonStylesProps } from "@/(admin)/modules/ui-builder/config/lib/commonCSSProps"
import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import Footer from "@/components/footer/index"
import { ComponentConfig } from "@measured/puck"

export interface FooterProps extends CommonStylesProps {
  logoImage: string
  slogan: string
  pagesColumn1: {
    title: string
    url: string
  }[]
  pagesColumn2: {
    title: string
    url: string
  }[]
  pagesColumn3: {
    title: string
    url: string
  }[]
  pagesColumn4: {
    title: string
    url: string
  }[]
  phone: string
  email: string
  advertisingContact: string
  facebookIcon: string
  facebookUrl: string
  youtubeIcon: string
  youtubeUrl: string
  copyrightText: string
}

export const RenderConfig: ComponentConfig<FooterProps> = {
  render: ({
    className,
    styles,
    responsiveType,
    logoImage,
    slogan,
    pagesColumn1,
    pagesColumn2,
    pagesColumn3,
    pagesColumn4,
    phone,
    email,
    advertisingContact,
    facebookIcon,
    facebookUrl,
    youtubeIcon,
    youtubeUrl,
    copyrightText,
  }) => {
    const id = `footer-${Math.random().toString(36).substr(2, 9)}`
    // still generate responsive CSS for builder preview scope
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _ = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <Footer
        logoImage={logoImage || ""}
        slogan={slogan || ""}
        pagesColumn1={pagesColumn1 || []}
        pagesColumn2={pagesColumn2 || []}
        pagesColumn3={pagesColumn3 || []}
        pagesColumn4={pagesColumn4 || []}
        phone={phone || ""}
        email={email || ""}
        advertisingContact={advertisingContact || ""}
        facebookIcon={facebookIcon || ""}
        facebookUrl={facebookUrl || ""}
        youtubeIcon={youtubeIcon || ""}
        youtubeUrl={youtubeUrl || ""}
        copyrightText={copyrightText || ""}
        className={className}
      />
    )
  },
}

export default RenderConfig
